import React, { useEffect, useRef, useState } from 'react';
import { LuTrash2 } from 'react-icons/lu';
import { Modal } from '../ui/Modal';
import Button from '../ui/Button';
import Alert from '../ui/Alert';
import { INPUT_CLASS } from '../ui/Field';

const CONFIRMATION_WORD = 'DELETE';

/** Irreversible deletion: the admin types DELETE to unlock the button. */
const DeleteReportModal = ({ isOpen, onClose, onConfirm, isDeleting = false, error = null, reportLabel }) => {
  const [confirmation, setConfirmation] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) setConfirmation('');
  }, [isOpen]);

  const confirmed = confirmation === CONFIRMATION_WORD;

  const submit = (e) => {
    e.preventDefault();
    if (confirmed && !isDeleting) onConfirm();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      dismissible={!isDeleting}
      icon={LuTrash2}
      iconTone="red"
      title="Supprimer le rapport"
      subtitle={reportLabel}
      size="sm"
      initialFocusRef={inputRef}
      footer={(
        <>
          <Button onClick={onClose} disabled={isDeleting}>Annuler</Button>
          <Button type="submit" form="delete-report-form" variant="danger" icon={LuTrash2} loading={isDeleting} disabled={!confirmed}>
            Supprimer définitivement
          </Button>
        </>
      )}
    >
      <form id="delete-report-form" onSubmit={submit} className="space-y-4">
        <Alert tone="danger" title="Action irréversible">
          Le rapport, ses analyses et ses données brutes seront supprimés.
        </Alert>
        <div>
          <label htmlFor="delete-confirmation" className="mb-1.5 block text-sm text-gray-700 dark:text-gray-300">
            Pour confirmer, saisissez <span className="font-mono font-bold">{CONFIRMATION_WORD}</span>
          </label>
          <input
            id="delete-confirmation"
            ref={inputRef}
            type="text"
            value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)}
            placeholder={CONFIRMATION_WORD}
            autoComplete="off"
            disabled={isDeleting}
            className={`${INPUT_CLASS} font-mono`}
          />
        </div>
        {error && <p className="text-sm text-red-600 dark:text-red-400" role="alert">{error}</p>}
      </form>
    </Modal>
  );
};

export default DeleteReportModal;
